export default class AnalyticElement {

    constructor(element:HTMLElement) {
        if(element.dataset.event) {
            element.addEventListener('click', () => {
                if(element.dataset.details) {
                    window.gtag('event', element.dataset.event, {
                        details: element.dataset.details,
                    });
                } else {
                    window.gtag('event', element.dataset.event);
                }
            })
        }
    }
}